import { GoogleMap, MarkerF } from "@react-google-maps/api"

const defaultContainerStyle = {
    width: '100%',
    height: '320px',
    borderRadius: '8px',
    border: '1px solid #d7deea',
}

const fallbackCenter = { lat: -37.8136, lng: 144.9631 }
const australiaBounds = { north: -9, south: -44.5, west: 112, east: 154.5 }

const AllocationMarkerMap = ({
    center,
    markerCoordinates = [],
    onMapClick,
    height = '320px',
    zoom,
    mapTypeId = 'roadmap',
}) => {
    const mapCenter = center && Number.isFinite(center.lat) && Number.isFinite(center.lng) ? center : fallbackCenter
    const hasMarker = Array.isArray(markerCoordinates) && markerCoordinates.length >= 2
        && Number.isFinite(Number(markerCoordinates[0]))
        && Number.isFinite(Number(markerCoordinates[1]))
    const resolvedZoom = Number.isFinite(Number(zoom)) ? Number(zoom) : (hasMarker ? 18 : 13)

    return (
        <GoogleMap
            mapContainerStyle={{ ...defaultContainerStyle, height }}
            center={mapCenter}
            zoom={resolvedZoom}
            onClick={onMapClick}
            options={{
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                mapTypeId,
                restriction: {
                    latLngBounds: australiaBounds,
                    strictBounds: true,
                },
            }}
        >
            {hasMarker && (
                <MarkerF position={{ lat: Number(markerCoordinates[0]), lng: Number(markerCoordinates[1]) }} />
            )}
        </GoogleMap>
    )
}

export default AllocationMarkerMap
